/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Cloud Platform Infragraph Service
 * APIs for managing Infragraph.
 *
 * The version of the OpenAPI document: 2025-05-07
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var HashicorpCloudInfragraph20250507LogicOperator;
(function (HashicorpCloudInfragraph20250507LogicOperator) {
    HashicorpCloudInfragraph20250507LogicOperator["UNSPECIFIED"] = "LOGIC_OPERATOR_UNSPECIFIED";
    HashicorpCloudInfragraph20250507LogicOperator["OR"] = "LOGIC_OPERATOR_OR";
    HashicorpCloudInfragraph20250507LogicOperator["AND"] = "LOGIC_OPERATOR_AND";
})(HashicorpCloudInfragraph20250507LogicOperator || (HashicorpCloudInfragraph20250507LogicOperator = {}));
export function HashicorpCloudInfragraph20250507LogicOperatorFromJSON(json) {
    return HashicorpCloudInfragraph20250507LogicOperatorFromJSONTyped(json, false);
}
export function HashicorpCloudInfragraph20250507LogicOperatorFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function HashicorpCloudInfragraph20250507LogicOperatorToJSON(value) {
    return value;
}
